var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.578125 1.27157V19.7287C0.578067 19.934 0.632775 20.1355 0.736604 20.3126C0.840434 20.4896 0.989624 20.6358 1.16878 20.7359C1.34794 20.8361 1.55058 20.8866 1.75579 20.8824C1.961 20.8781 2.16135 20.8191 2.33617 20.7116L17.3326 11.483C17.5006 11.3798 17.6393 11.2352 17.7355 11.0632C17.8317 10.8911 17.8822 10.6973 17.8822 10.5001C17.8822 10.303 17.8317 10.1092 17.7355 9.9371C17.6393 9.76504 17.5006 9.62051 17.3326 9.5173L2.33617 0.288729C2.16135 0.181176 1.961 0.122214 1.75579 0.117927C1.55058 0.113641 1.34794 0.164185 1.16878 0.264344C0.989624 0.364503 0.840434 0.510651 0.736604 0.687707C0.632775 0.864764 0.578067 1.06632 0.578125 1.27157Z",
    fill: "#382C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBlackIcon);
export default __webpack_public_path__ + "static/media/play-black-icon.5930cdf6a045072eb1b88234c3ae1f0a.svg";
export { ForwardRef as ReactComponent };